<template>
  <div v-if="!$store.getters.translationsLoaded">
    <base-loader></base-loader>
  </div>
  <div v-else>
    <keep-alive>
      <active></active>
    </keep-alive>
    <snack-bar></snack-bar>
  </div>
</template>

<script>
// import * as am4core from '@amcharts/amcharts4/core'
// import { am4themesEfdThemeAchr } from '@/themes'
// import active from '@/components/dashboards/rm/DashboardRmAppointments'
import auth from '@/api/auth'
import BaseLoader from '../components/loaders/BaseLoader'
import SnackBar from '../components/snackbars/SnackBar'
// am4core.useTheme(am4themesEfdThemeAchr)

export default {
  name: 'BIdashboard',
  components: {
    // active
    BaseLoader,
    SnackBar
  },
  methods: {

  },
  // beforeRouteUpdate (to, from, next) {
  //   let component = Object.values(this.$options.components).find(component => component.name === to.params.id)
  //   if (component) {
  //     next()
  //   } else {
  //     next('page-not-found')
  //   }
  // },
  beforeCreate () {
    this.$store.commit('SET_CURRENCY', process.env.VUE_APP_CURRENCY)
    // TODO: refactor to be only on one component (App.vue)
    // set language from query param
    if (this.$route.query && this.$route.query.lang) {
      this.$log.info('Route query Language:', this.$route.query.lang)
      this.$store.commit('SET_LANGUAGE', this.$route.query.lang)
      this.$store.dispatch('fetchTranslations')
    } else {
      this.$store.commit('SET_LANGUAGE', 'en')
      this.$store.dispatch('fetchTranslations')
    }

    // camelize function
    let camelize = (text, separator = '-') => (
      text.split(separator)
        .map(w => w.replace(/./, m => m.toUpperCase()))
        .join('')
    )
    // set token from url
    this.$store.commit('SET_AUTH_TOKEN', this.$route.params.token)
    auth.setAuthToken(this.$route.params.token)
    // build component name
    let slug = camelize(this.$route.params.id)
    let componentName = 'Dashboard' + slug
    let platform = this.$route.params.platform
    // load component
    // on error display message
    this.$options.components.active = () => import('@/components/dashboards/' + platform + '/' + componentName).catch((err) => ({
      render: h => h('div', [
        h('h1', 'Invalid dashboard'),
        h('p', err)
      ])
    }))
  },
  destroyed () {
    this.store.commit('SET_CURRENCY', '')
  }
}
</script>
